// extracted by mini-css-extract-plugin
export default {"container":"WRE07","component":"dH4ta","component--no-grow":"UIV4N"};